import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { ICloud } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/admin/clouds';
const $urlCount = '/admin/clouds/actions/count';

export interface IGetRequest {
  currentPage: number;
  cloudType: string;
  offset: number;
  limit: number;
  dateFrom: string;
  dateTo: string;
  orderByIdDesc: boolean;
}

interface IGetResult {
  count: number;
  clouds: ICloud[];
}

export interface IAddRequest {
  userName: string;
  cloudType: string;
  expirationDate: Date;
}

export interface IEditRequest {
  userId: number;
  expirationDate: Date;
}

export interface ICountRequest {
  userId: number;
}

export interface ICloudProductCount {
  product: string;
  maxCount: number;
  count: number;
  unit: string;
}

interface ICountResult {
  counts: ICloudProductCount[];
}

export default {
  get(req: IGetRequest, success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url, {
        params: req,
      })
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  add(req: IAddRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  edit(req: IEditRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .put($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  delete(userId: number, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .delete($url, {
        data: {
          userId,
        },
      })
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  count(req: ICountRequest, success: (res: ICountResult) => void) {
    utils.loading(true);
    request
      .post($urlCount, req)
      .then((response: AxiosResponse<ICountResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
